import backToTop from '../modules/backToTop.js';
import movingLabel from '../modules/movingLabel.js';
import togglePanel from '../../shared/toggle-panel.js';
import tooltip from '../modules/tooltip.js';

(function (Drupal, drupalSettings, $) {
  Drupal.behaviors.navigation = {
    attach: (context, settings) => {
      if (context === document) {
        const navigationCheckReadyState = setInterval(() => {
          // BigPipe may cause this block to be called too early, wait for readyState complete.
          if (document.readyState === 'complete') {
            clearInterval(navigationCheckReadyState);
            (function () {
              if (document.body.getAttribute('data-navigations') === 'true') {
                return;
              }
              enableSkipLinks();
              hideLateralMenu();
              enableBurger();
              enableMobilizeMenu();
              enableProfileAccess();
              enableSticky();
              temoignagesMasonry();
              disableRightClick();
              toggleSearch();
              toggleNetwork();
              enableFooter();
              enableFAQ();
              enableTooltip();
              enableModalTrigger();
              cgu();
              scrollToAnchor();
              stickyPanel();
              exitIntentModal();
              showHideTestimonyText();
              document.body.setAttribute('data-navigations', 'true');
            }());
          }
        }, 100);
      }

      const testimonyDisplay = document.querySelector('.testimonials-display');
      const testimonyPrivateDisplay = document.querySelector('.testimonies-private-display');
      if (context === testimonyDisplay || context === testimonyPrivateDisplay) {
        temoignagesMasonry();
        enableModalTrigger();
        disableRightClick();
      }

      const paragraphTwoColumns = document.querySelector('.paragraph--two-columns');
      if (context === document.getElementById('preregister-wrapper') || context === paragraphTwoColumns) {
        enableTooltip();
        enableModalTrigger();
      }

      $(document).ajaxComplete(() => {
        if (document.body.getAttribute('ajax-reload') === 'true' && $('.multiple-user-tabs__menu').length > 0) {
          return;
        }
        menuSelectColor();
        enableMobilizeMenu();
        document.body.setAttribute('ajax-reload', 'true');
      });
    }
  };

  /**
   * Show Modal before leaving.
   *
   * @return {void};
   */
  function exitIntentModal() {
    // Check if the exit intent is enabled in config.
    if (!drupalSettings.ddmo_exit_intent || !drupalSettings.ddmo_exit_intent.enabled) {
      return;
    }

    // Check if the dialog has been closed before.
    if (Cookies.get('ddmo_exit_intent.popup.disabled')) {
      return;
    }

    const duration = 5000;

    // Create the dialog after 5 seconds.
    setTimeout(() => {
      $(document).on('mouseleave', (evt) => {
        // This test is perfectible. if user hover the autocomplete
        // component comming from other element, the modal will display.
        if (Cookies.get('ddmo_exit_intent.popup.disabled')) {
          return;
        }

        if (evt.relatedTarget === null && evt.target.nodeName !== 'INPUT') {
          // Do not display if user is logged.
          if (document.body.classList.contains('user-logged-in')) {
            return;
          }

          // An intent to exit has happened, remove the event to prevent another trigger.
          $(evt.currentTarget).off('mouseout');

          // Lazy-load the webform via AJAX before opening the modal.
          // This keeps the initial page HTML free of session tokens and captcha,
          // allowing the CDN to cache the page.
          const openExitIntentColorbox = function () {
            const colorboxSettings = colorboxDefault;
            colorboxSettings.open = true;
            colorboxSettings.maxWidth = '96%';
            colorboxSettings.href = '#exit-intent';
            colorboxSettings.innerWidth = '700';
            colorboxSettings.onClosed = function () {
              // Prevent dialog opening for 30 days.
              Cookies.set('ddmo_exit_intent.popup.disabled', 'true', { expires: 30 });
              document.body.classList.remove('modal-is-open');
            };
            colorboxSettings.onComplete = function () {
              const labelList = document.querySelectorAll('.modal--exit-intent label');
              [].forEach.call(labelList, (label) => {
                movingLabel(label);
              });
            };

            $.colorbox(colorboxSettings);
          };

          const exitIntentContainer = document.querySelector('#exit-intent .modal__content');
          if (exitIntentContainer && !exitIntentContainer.dataset.loaded) {
            fetch(Drupal.url('exit-intent/form'))
              .then(function (response) {
                if (!response.ok) {
                  throw new Error('Failed to load exit-intent form');
                }
                return response.text();
              })
              .then(function (html) {
                exitIntentContainer.innerHTML = html;
                exitIntentContainer.dataset.loaded = 'true';
                // Attach Drupal behaviors to the freshly loaded form.
                if (window.Drupal && window.Drupal.attachBehaviors) {
                  window.Drupal.attachBehaviors(exitIntentContainer);
                }
                openExitIntentColorbox();
              })
              .catch(function () {
                // Fallback: open the modal with whatever content is there.
                openExitIntentColorbox();
              });
          } else {
            openExitIntentColorbox();
          }
        }
      });
    }, duration);
  }

  function scrollToAnchor() {
    const anchor = window.location.hash;

    if (!anchor || !document.querySelector(anchor)) {
      return;
    }

    // Get destination.
    const scrollOffset = 250;
    const scrollDestination = document.querySelector(anchor).getBoundingClientRect().top + window.scrollY - scrollOffset;

    // Smooth.
    window.scroll({
      top: scrollDestination,
      left: 0,
      behavior: 'smooth',
    });
  }

  /**
   * Toggle the sticky navigation.
   *
   * @return {void};
   */
  function enableSticky() {
    const doc = document.documentElement;
    const body = document.body;
    const fixedClass = 'header__nav--is-fixed';
    const bodyFixedClass = 'header-is-fixed';
    const header = document.querySelector('.header__nav');
    const headerTop = document.querySelector('.header__inner');
    const treshold = headerTop.getBoundingClientRect().height;
    let isFixed = false;

    window.addEventListener('scroll', () => {
      const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

      isFixed = scrollTop >= treshold;

      if (isFixed) {
        header.classList.add(fixedClass);
        body.classList.add(bodyFixedClass);
      } else {
        header.classList.remove(fixedClass);
        body.classList.remove(bodyFixedClass);
      }
    });
  }

  /**
   * Toggle the burger navigation.
   *
   * @return {void};
   */
  function enableBurger() {
    const burger = document.getElementById('burger');
    if (!burger) {
      return;
    }

    togglePanel(burger, {
      panel: '.burger-nav',
      panelLabel: 'Menu principal',
    });

    // Close button.
    const burgerClose = document.querySelector('.burger-nav__close');
    burgerClose.addEventListener('click', () => {
      burger.click();
    });
    const burgerBottomClose = document.querySelector('.close-bottom');
    if (burgerBottomClose) {
      burgerBottomClose.addEventListener('click', () => {
        burger.click();
      });
    }
  }

  /**
   * Toggle the profil access navigation.
   *
   * @return {void};
   */
  function enableProfileAccess() {
    const profilAccess = document.getElementById('profil-access');
    if (!profilAccess) {
      return;
    }
    $('#profil-access').on('click', () => {
      $('#profil-menu').toggleClass('signin-logged__block--show');
    });
  }

  /**
   * Toggle the profil access navigation.
   *
   * @return {void};
   */


  function enableMobilizeMenu() {
    let $formId;
    let $initList;
    if ($('#views-exposed-form-mobilize-your-relatives-private-share-my-relatives-mobile').length > 0) {
      $formId = $('#views-exposed-form-mobilize-your-relatives-private-share-my-relatives-mobile').find('select');
      $initList = 1;
    } else if ($('#views-exposed-form-mobilize-your-loved-ones-promoted-mobile').length > 0) {
      $formId = $('#views-exposed-form-mobilize-your-loved-ones-promoted-mobile').find('select');
      $initList = 0;
    } else if ($('#views-exposed-form-testimonies-private-display-testimonies-private-display-mobile').length > 0) {
      $formId = $('#views-exposed-form-testimonies-private-display-testimonies-private-display-mobile').find('select');
      $initList = 0;
    } else if ($('#views-exposed-form-testimonials-display-testimonials-display-mobile').length > 0) {
      $formId = $('#views-exposed-form-testimonials-display-testimonials-display-mobile').find('select');
      $initList = 0;
    } else if ($('#views-exposed-form-faq-questions-faq-questions-mobile').length > 0) {
      $formId = $('#views-exposed-form-faq-questions-faq-questions-mobile').find('select');
      $initList = 0;
    } else if ($('#views-exposed-form-faq-questions-private-faq-questions-mobile').length > 0) {
      $formId = $('#views-exposed-form-faq-questions-private-faq-questions-mobile').find('select');
      $initList = 0;
    } else {
      return;
    }

    const $selectMenu = $formId;
    $selectMenu.each(function () {
      // eslint-disable-next-line max-statements-per-line
      const $this = $(this);
      const numberOfOptions = $(this).children('option').length;

      $this.addClass('select-hidden');
      $this.wrap('<div class="multiple-user-tabs__menu"></div>');
      $this.after('<div class="multiple-user-tabs__menu--select"></div>');
      const $styledSelect = $this.next('div.multiple-user-tabs__menu--select');
      $styledSelect.text($this.find('option:selected').text());
      const $list = $('<ul />', {
        class: 'multiple-user-tabs__options'
      }).insertAfter($styledSelect);
      for (let i = $initList; i < numberOfOptions; i++) {
        $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val(),
        }).appendTo($list);
      }
      const $listItems = $list.children('li');
      const $selectedValue = $this.find('option:selected').val();
      $listItems.filter(`[rel="${$selectedValue}"]`).addClass('select-hidden');

      $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.multiple-user-tabs__menu--select.active').each(() => {
          $($this).removeClass('active').next('ul.multiple-user-tabs__options').hide();
        });
        $(this).toggleClass('active').next('ul.multiple-user-tabs__options').toggle();
      });

      $listItems.click(function (e) {
        e.stopPropagation();
        const $clickedItem = $(this);
        const $valSelected = $clickedItem.attr('rel');

        $styledSelect.text($clickedItem.text()).removeClass('active');
        $this.val($valSelected);

        $selectMenu.find('option').each(function () {
          const $option = $(this);
          if ($option.val() === $valSelected) {
            $option.prop('selected', true);
          } else {
            $option.prop('selected', false);
          }
        });

        $listItems.removeClass('select-hidden');
        $listItems.filter(`[rel="${$valSelected}"]`).addClass('select-hidden');

        $selectMenu.trigger('change');
        $styledSelect.trigger('classRemoved', $(this).attr('rel'));
        $list.hide();
        document.body.setAttribute('ajax-reload', 'false');
      });
    });
  }

  /**
   * Go to the top of the page.
   *
   * @return {void};
   */
  function enableBackToTop() {
    const backToTopButton = document.getElementById('back-to-top');
    if (!backToTopButton) {
      return;
    }

    backToTop(backToTopButton, {
      threshold: 300,
      offset: 200
    });
  }

  /**
   * Sticky update panel.
   *
   * @return {void};
   */
  function stickyPanel() {
    const doc = document.documentElement;
    const body = document.body;
    const bodyFixedClass = 'panel-is-fixed';
    const fixedClass = 'logged-panel__update--is-fixed';
    const panel = document.querySelector('.logged-panel__update');
    const panelTop = document.querySelector('.header');
    const userPanelHeight = 62;
    const treshold = panelTop.getBoundingClientRect().height + userPanelHeight;
    let isFixed = false;

    if (!panel) {
      return;
    }

    window.addEventListener('scroll', () => {
      const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

      isFixed = scrollTop >= treshold;

      if (isFixed) {
        panel.classList.add(fixedClass);
        body.classList.add(bodyFixedClass);
      } else {
        panel.classList.remove(fixedClass);
        body.classList.remove(bodyFixedClass);
      }
    });
  }

  /**
   * Enable the tooltips.
   *
   * @return {void};
   */
  function enableTooltip() {
    const elementsWithTooltip = document.querySelectorAll('[data-help]');

    let event = 'click';
    if (window.matchMedia('(max-width: 767px)').matches) {
      event = 'click';
    }

    [].forEach.call(elementsWithTooltip, (el) => {
      togglePanel(el, {
        panel: 'next',
        event,
        eventHide: 'mouseleave',
        mode: 'custom',
        autoFocus: false,
        customShow: (panel, trigger) => {
          // Do the positionning.
          let xOffset = 50;
          const yOffset = 20;
          let placement = 'top';

          if (window.matchMedia('(max-width: 767px)').matches) {
            xOffset = 0;
            placement = 'bottom';
          }

          Popper.createPopper(trigger, panel, {
            placement,
            modifiers: [{
              name: 'offset',
              options: {
                offset: [xOffset, yOffset],
              },
            }],
          });
        }
      });
    });

    // Map tooltip.
    const mapTooltip = document.querySelectorAll('.svg-map a');

    let mapParent = null;
    const mapRenseignez = document.querySelector('.region-carte-dynamique__map');
    const mapHome = document.querySelector('.map__map');
    if (mapRenseignez) {
      mapParent = mapRenseignez;
    } else if (mapHome) {
      mapParent = mapHome;
    }

    if (!mapParent) {
      return;
    }

    [].forEach.call(mapTooltip, (el) => {
      tooltip(el, {
        tooltip: document.getElementById('map-tooltip'),
        contentFrom: el.getAttribute('title'),
        screen: 'all',
        class: 'map__tooltip',
        reference: mapParent,
        offsetX: 30,
        allowClickEvent: true,
      });
    });
  }

  /**
   * Hide the lateral menu after timeout.
   *
   * @return {void};
   */
  function hideLateralMenu() {
    const lateralDelay = 2000;
    const lateral = document.querySelector('.block-menu--lateral, .block-menu--lateral-logged');
    if (!lateral) {
      return;
    }

    // The lateral menu is displayed a few seconds on these pages.
    if (document.querySelector('.menu-main .menu-item--active-trail')) {
      document.body.classList.add('menu-lateral-is-open');
    } else {
      lateral.classList.add('is-off-screen');
    }

    // Hide menu after timeout.
    setTimeout((menuLateral) => {
      menuLateral.classList.add('is-off-screen');
    }, lateralDelay, lateral);
  }

  /**
   * Toggle mobile footer.
   *
   * @return {void};
   */
  function enableFooter() {
    const button = document.getElementById('footer-collapse');
    if (!button) {
      return;
    }

    togglePanel(button, {
      panel: '#block-footer',
      panelLabel: 'Menu information',
      outsideClose: false,
    });
  }

  /**
   * Shows skip links on focus and add an outline on the targeted element.
   *
   * @return {void};
   */
  function enableSkipLinks() {
    const targetClass = 'skip-links__target';
    const linksList = document.querySelectorAll('#skip-links a');

    [].forEach.call(linksList, (link) => {
      link.addEventListener('focus', () => {
        document.querySelector(link.hash).classList.add(targetClass);
      });

      link.addEventListener('blur', () => {
        document.querySelector(link.hash).classList.remove(targetClass);
      });
    });
  }

  function toggleSearch() {
    const button = document.getElementById('search-toggle');
    if (!button) {
      return;
    }

    togglePanel(button, {
      panel: '#search-block-form',
      panelLabel: 'Recherche',
      outsideClose: false,
    });

    const close = document.getElementById('search-close');
    const panel = document.getElementById('search-block-form');
    if (!close) {
      return;
    }

    close.addEventListener('click', () => {
      panel.dispatchEvent(new CustomEvent('hide'));
    });
  }

  function toggleNetwork() {
    const button = document.getElementById('edit-network--toggle');
    if (!button) {
      return;
    }

    togglePanel(button, {
      panel: '#edit-network',
      panelLabel: 'Partage',
      outsideClose: false,
    });
  }

  /**
   * Ferme les autres questions ouvertes de la même liste (DVMO-221).
   *
   * Chaque question figure dans la liste desktop et dans la liste mobile :
   * on ne ferme que dans la liste de la question ouverte. La position de la
   * question ouverte est conservée à l'écran quand une réponse au-dessus
   * se replie.
   *
   * @param {HTMLElement} panel
   *   Le panneau de la question qui vient d'être ouverte.
   * @param {HTMLElement} trigger
   *   Le bouton de la question.
   *
   * @return {void}
   */
  function closeOtherQuestions(panel, trigger) {
    const row = panel.closest('.faq-questions__row');
    const list = panel.closest('.faq__list') || row && row.parentElement;
    if (!list) {
      return;
    }
    const top = trigger.getBoundingClientRect().top;
    const opened = list.querySelectorAll('.faq-questions__row > .tgp__panel--is-opened');
    [].forEach.call(opened, (other) => {
      if (other !== panel) {
        other.dispatchEvent(new CustomEvent('hide', { detail: { returnFocus: false } }));
      }
    });
    const shift = trigger.getBoundingClientRect().top - top;
    if (shift !== 0 && trigger.offsetParent !== null) {
      window.scrollBy(0, shift);
    }
  }

  /**
   * Toggle FAQ questions.
   *
   * @return {void};
   */
  function enableFAQ() {
    const faqTitleList = document.querySelectorAll('.question__switch');
    [].forEach.call(faqTitleList, (faq) => {
      togglePanel(faq, {
        panel: 'next',
        panelLabel: 'Réponse',
        outsideClose: false,
        onShow: closeOtherQuestions,
      });
    });

    // Synchronise la barre d'adresse avec la dernière question ouverte
    // (DVMO-221) : URL dédiée de la question, sans nouvelle entrée
    // d'historique.
    const faqRows = document.querySelectorAll('[data-faq-url]');
    [].forEach.call(faqRows, (row) => {
      const panel = row.querySelector('.tgp__panel');
      if (!panel || !window.history.replaceState) {
        return;
      }
      panel.addEventListener('show', () => {
        const url = row.getAttribute('data-faq-url');
        if (url && window.location.pathname !== url) {
          window.history.replaceState(window.history.state, '', url);
        }
      });
    });

    // Question à ouvrir : page dédiée de la question (DVMO-221) ou ancien
    // lien #question-X (X = nid de la question).
    let questionId = drupalSettings.ddmoFaq && drupalSettings.ddmoFaq.question
      ? String(drupalSettings.ddmoFaq.question)
      : '';
    const hashPrefix = '#question-';
    if (!questionId && window.location.hash.indexOf(hashPrefix) === 0) {
      questionId = window.location.hash.substring(hashPrefix.length);
    }
    if (!questionId) {
      return;
    }

    // La question figure dans la liste desktop et dans la liste mobile : on
    // ouvre les deux, on fait défiler jusqu'à celle qui est visible.
    const questionRows = document.querySelectorAll(`[data-faq-id="${questionId}"]`);
    let visibleRow = null;
    [].forEach.call(questionRows, (row) => {
      const question = row.querySelector('.tgp__panel');
      if (question) {
        question.dispatchEvent(new CustomEvent('show'));
      }
      if (!visibleRow && row.offsetParent !== null) {
        visibleRow = row;
      }
    });
    if (!visibleRow) {
      return;
    }

    setTimeout(() => {
      const scrollOffset = 250;
      const scrollDestination = visibleRow.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scroll({
        top: scrollDestination,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  }

  /**
   * Listen modal trigger.
   *
   * @return {void};
   */
  function enableModalTrigger() {
    // Open modal.
    const colorboxSettings = colorboxDefault;
    colorboxSettings.innerWidth = '500'; // 400

    // Display modal on click on these elements.
    const $triggers = $('[data-modal]');

    $triggers.each((i, el) => {
      const modalId = $(el).attr('data-modal');
      colorboxSettings.href = `#${modalId}`;
      colorboxSettings.className = `modal--${modalId}`;
      colorboxSettings.open = false;

      if (colorboxSettings.href.includes('video')) {
        colorboxSettings.innerWidth = '700';
        colorboxSettings.initialHeight = '300';
      }

      if (colorboxSettings.href.includes('edit-avatar-modal')) {
        colorboxSettings.innerWidth = '1080';
        colorboxSettings.initialHeight = '300';
        colorboxSettings.className = 'colorbox--avatar';
        colorboxSettings.close = `<img src="${drupalSettings.path.baseUrl}${drupalSettings.path.themeUrl}/assets/img/icons/close-brand.svg" alt="Fermer la fenêtre" title="Fermer la fenêtre">`;
      }

      // Open modal with url parametter.
      if (getParam('id') === modalId) {
        colorboxSettings.open = true;

        // Smooth with position control.
        el.scrollIntoView({
          block: 'center',
        });
      }

      $(el).colorbox(colorboxSettings);
    });

    // Resize modal on activating youtube cookies.
    // We used a delegated event because the buttons doesn't exists at page load.
    document.addEventListener('click', (e) => {
      if (e.target.matches('.tac_activate_youtube .tarteaucitronAllow')) {
        tarteaucitron.triggerJobsAfterAjaxCall();
        $.colorbox.resize();
      }
    });

    // Get all auto-opened modal.
    const $modalOpen = $('.modal-open');

    $modalOpen.each((i, el) => {
      const modalId = $(el).attr('id');

      colorboxSettings.href = `#${modalId}`;
      colorboxSettings.className = `modal--${modalId}`;
      colorboxSettings.open = true;

      if (colorboxSettings.href.includes('show-video')) {
        colorboxSettings.innerWidth = '700';
        colorboxSettings.initialHeight = '300';
      }

      if (colorboxSettings.href.includes('show-woman-info')) {
        colorboxSettings.onClosed = () => {
          console.log(document.getElementById('show-woman-info'));
          const link = document.querySelector(`${colorboxSettings.href} .modal__actions .btn`);
          window.location.href = link.getAttribute('href');
        };
      }

      if (colorboxSettings.href.includes('welcome-pop-in')) {
        colorboxSettings.maxWidth = '98%';
        colorboxSettings.innerWidth = '1028';
        colorboxSettings.initialHeight = '300';
        colorboxSettings.className = `colorbox--${modalId}`;
        colorboxSettings.close = `<img src="${drupalSettings.path.baseUrl}${drupalSettings.path.themeUrl}/assets/img/icons/close-b.svg" alt="Fermer la fenêtre" title="Fermer la fenêtre">`;
      }

      $.colorbox(colorboxSettings);
    });
  }

  /**
   * Toggle CGU.
   *
   * @return {void};
   */
  function cgu() {
    const cguTrigger = document.querySelector('.form__item-check label a');
    if (!cguTrigger) {
      return;
    }

    togglePanel(cguTrigger, {
      panel: 'function',
      findPanel: () => document.querySelector('.tos-text'),
      outsideClose: false,
      connect: true,
      wrapper: document.querySelector('.container--edit-legal'),
    });

    // Avoid checking the box.
    cguTrigger.addEventListener('click', (e) => {
      e.preventDefault();
    });

    const privacyTriggerList = document.querySelectorAll('.form__item-check label a');
    const limit = 2;
    if (privacyTriggerList.length < limit) {
      return;
    }

    const privacyTrigger = privacyTriggerList[privacyTriggerList.length - 1];
    if (!privacyTrigger) {
      return;
    }

    togglePanel(privacyTrigger, {
      panel: 'function',
      findPanel: () => document.querySelector('.privacy-text'),
      outsideClose: false,
      connect: true,
      wrapper: document.querySelector('.container--edit-legal'),
    });

    // Avoid checking the box.
    privacyTrigger.addEventListener('click', (e) => {
      e.preventDefault();
    });
  }

  function temoignagesMasonry() {
    // Masonry
    // @see https://masonry.desandro.com.
    const rows = document.querySelector('.views-infinite-scroll-content-wrapper .testimonials-display__row');
    if (!rows) {
      return;
    }

    const msnry = new Masonry('.views-infinite-scroll-content-wrapper', {
      itemSelector: '.testimonials-display__row',
      columnWidth: 315,
      fitWidth: true,
      gutter: 16,
      horizontalOrder: true,
    });
  }

  function disableRightClick() {
    const $buttonClass = '.testimonies-private-display .pager__item .button';

    $($buttonClass).on('contextmenu', (event) => {
      event.preventDefault();
    });

    $($buttonClass).on('click mousedown', (event) => {
      if (event.which === 2) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function showHideTestimonyText() {
    if ($('#testimony__contrib--extended').length > 0) {
      const $textDiv = $('.testimony__body');
      const $button = $('#testimony__contrib--extended');

      const smallScreenWidth = 768;
      const smallScreenHeight = 580;
      if ($(window).width() < smallScreenWidth && $textDiv.get(0).scrollHeight > smallScreenHeight) {
        $button.show();
        $textDiv.addClass('hide-text');
        $button.find('.icon--disc-plus').show();
      } else {
        $button.hide();
      }

      $($button).click(() => {
        if ($textDiv.hasClass('hide-text')) {
          $textDiv.removeClass('hide-text');
          $button.find('.visually-hidden').text('Afficher moins');
          $button.find('.icon--disc-plus').hide();
          $button.find('.icon--disc-minus').show();
        } else {
          $textDiv.addClass('hide-text');
          $button.find('.visually-hidden').text('Afficher plus');
          $button.find('.icon--disc-minus').hide();
          $button.find('.icon--disc-plus').show();
        }
      });
    }
  }

  function menuSelectColor() {
    const $formsSelect = [
      {
        form: $('#views-exposed-form-locations-associations-private-block'),
        region: $('#edit-region-association'),
        department: $('#form-department-association').find('.form-select')
      },
      {
        form: $('#views-exposed-form-locations-centres-private-block'),
        region: $('#edit-region-centre'),
        department: $('#form-department-centre').find('.form-select')
      }
    ];

    $formsSelect.forEach(({ form, region, department }) => {
      if (form.length > 0) {
        if (region.val() !== 'All') {
          region.addClass('form-select--active');
        } else {
          region.removeClass('form-select--active');
        }
        if (department.val() !== 'All') {
          department.addClass('form-select--active');
        } else {
          department.removeClass('form-select--active');
        }
      }
    });
  }
}(Drupal, drupalSettings, jQuery));
